import React from 'react'
import { Grid, Checkbox, Button, Icon,Popup } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
import diamond from '../../../../../images/grafix-icon/diamond.svg';
import Labels from './../../../../common/Labels'
import { connect } from 'react-redux';
import SmartIntegration from '../SmartIntegration/SmartIntegration';
import { singleLineText } from '../../../../common/RegexValidation';
import SingleLineEditText from '../../../../common/SingleLineEditText';
import MultiLineEditText from '../../../../common/MultiLineEditText';


let Milestone = false;
let SmartActivity = false;

let actObj = {}
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Activity Summary Card")
})
class CommunityActivityResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            buttonPressed: false,
            activityStatus: props.selectedPracticeFlowActivity && props.selectedPracticeFlowActivity.isActivityDisabled || false
        }
        this.updateActivityData = this.updateActivityData.bind(this);
        this.setMilestone = this.setMilestone.bind(this);
        this.setActivitySmart = this.setActivitySmart.bind(this);
        this.setActivityStatus = this.setActivityStatus.bind(this);
        this.keyPress = this.keyPress.bind(this);
    }

    updateActivityData(e) {
        if (e.target.name === 'duration') {
            e.target.value = e.target.value.replace(/^0+/, '');
            if (/^((?!(0))[0-9]{1,3})$/.test(e.target.value)) {
                this.props.selectedPracticeFlowActivity.duration = e.target.value;
                dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
            }
            else if (!(e.target.value)) {
                this.props.selectedPracticeFlowActivity.duration = null;
                dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
            }
        }
    }

    setMilestone(data) {
        if (data) {
            Milestone = !Milestone;
            this.props.selectedPracticeFlowActivity.isMilestone = Milestone;
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
        }
    }
    setActivitySmart(data) {
        if (data) {
            SmartActivity = !SmartActivity;
            this.props.selectedPracticeFlowActivity.isSmartActivity = SmartActivity;
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
        }
        if(!SmartActivity || SmartActivity == false){
            dispatch.lifeCycle.deleteAllActivityActionsForId(this.props.selectedPracticeFlowActivity._id);
        }
    }
    setActivityStatus = async (e, data) => {
        const newStatus = data.checked;
      
        this.setState({ activityStatus: newStatus });
      
        try {
          await dispatch.lifeCycle.updateActivityStatus({
            id: this.props.selectedPracticeFlowActivity._id,
            isActivityDisabled: newStatus
          });
      
          this.props.selectedPracticeFlowActivity.isActivityDisabled = newStatus;
        } catch (error) {
          console.error("Failed to update activity status:", error);
      
          this.setState(prevState => ({
            activityStatus: !prevState.activityStatus
          }));
        }
      }
      
    
    keyPress(e) {

        if (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 27) {
            if (e.target.name === 'duration') {
                e.target.value = e.target.value.replace(/^0+/, '');
                if (/^((?!(0))[0-9]{1,3})$/.test(e.target.value)) {
                    this.props.selectedPracticeFlowActivity.duration = e.target.value;
                    dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
                }
                else if (!(e.target.value)) {
                    this.props.selectedPracticeFlowActivity.duration = null;
                    dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
                }
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (
          prevProps.selectedPracticeFlowActivity !== this.props.selectedPracticeFlowActivity &&
          this.props.selectedPracticeFlowActivity
        ) {
          this.setState({
            activityStatus: this.props.selectedPracticeFlowActivity.isActivityDisabled || false
          });
        }
      }
      
    componentWillUnmount() {
        if (this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.duration && (/^((?!(0))[0-9]{1,3})$/.test(this.props.selectedPracticeFlowActivity.duration))) {
            return;
        }
        else {
            this.props.selectedPracticeFlowActivity.duration = null;
        }
    }

    componentWillMount() {
        actObj = Object.assign({}, this.props.selectedPracticeFlowActivity);
    }

    saveDuration = (data) => {
        data = data.text.toString();
        data = data.replace(/^0+/, '');
        if (/^((?!(0))[0-9]{1,3})$/.test(data)) {
            this.props.selectedPracticeFlowActivity.duration = data;
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
        }
        else if (!(data)) {
            this.props.selectedPracticeFlowActivity.duration = null;
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
        }

    }

    saveData = (data) => {
        if (data.name === 'Name') {
            this.props.selectedPracticeFlowActivity.name = data.text;
            if ((singleLineText.test(data.text))) {
                dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
            }
            else {
                this.props.selectedPracticeFlowActivity.name = actObj.name;
            }
        } else if (data.name === 'Description') {
            this.props.selectedPracticeFlowActivity.description = data.text;
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
        }

    }
    toggleButttonPressed = ()=>{
        this.setState({buttonPressed:true})
    }
    render() {
        Milestone = this.props.selectedPracticeFlowActivity ? this.props.selectedPracticeFlowActivity.isMilestone : false;
        SmartActivity = (this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.isSmartActivity) ? this.props.selectedPracticeFlowActivity.isSmartActivity : false;
        // ActivityStatus = (this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.isActivityDisabled) ? this.props.selectedPracticeFlowActivity.isActivityDisabled : false;

        return (
            <Form noValidate
                className="formcyForm"
                ref={ref => this.form = ref}
                onValidSubmit={this.props.onSubmit}
            >
                <Grid style={{width:"100%"}}>
                    <Grid.Row>
                    
                        <Grid.Column width={16}>
                            {this.props.status !== 0 ?
                                <Labels
                                    name="Name"
                                    text={this.props.selectedPracticeFlowActivity.name} />
                                :
                                <SingleLineEditText
                                    name="Name"
                                    text={this.props.selectedPracticeFlowActivity.name}
                                    type="text"
                                    onSaveClick={this.saveData}
                                />
                            }
                        </Grid.Column>

                        <Grid.Column width={16}>
                            {this.props.status !== 0 ?
                                <Labels
                                    name="Description"
                                    text={this.props.selectedPracticeFlowActivity.description}
                                    htmlView={true} />
                                :
                                <MultiLineEditText
                                    name="Description"
                                    text={this.props.selectedPracticeFlowActivity.description}
                                    type="textarea"
                                    onSaveClick={this.saveData}
                                    htmlView={true}
                                />
                            }
                        </Grid.Column>
                        {this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.isParentNode ? '' :
                            <Grid.Column width={10}>
                                {this.props.status !== 0 ?

                                    <Labels
                                        name="Duration (In Days)"
                                        text={this.props.selectedPracticeFlowActivity.duration} />
                                    :
                                    <SingleLineEditText
                                        name="Duration (In Days)"
                                        text={this.props.selectedPracticeFlowActivity.duration ? this.props.selectedPracticeFlowActivity.duration : 0}
                                        type="text"
                                        id="duration"
                                        valueType="duration"
                                        onSaveClick={this.saveDuration}
                                    />
                                    // <EditDuration
                                    //     name="Duration (In Days)"
                                    //     text={this.props.selectedPracticeFlowActivity.duration ? this.props.selectedPracticeFlowActivity.duration : 0}
                                    //     id="duration"
                                    //     saveDuration={this.saveDuration}
                                    //     htmlView={true}
                                    // />

                                }
                            </Grid.Column>}

                        {this.props.selectedPracticeFlowActivity &&
                        this.props.selectedPracticeFlowActivity.parentActivity &&
                        !this.props.selectedPracticeFlowActivity.isLeafNode  && 
                        this.props.status === 0 &&
                        this.props.selectedAccount && this.props.selectedAccount.integrations && 
                         this.props.selectedAccount.integrations.length > 0 ? (
                        <SmartIntegration
                          selectedAccount={this.props.selectedAccount}
                          selectedPracticeFlowActivity={
                          this.props.selectedPracticeFlowActivity
                         }
                         page="sequence"
                         buttonPressed={false}
                         toggleButttonPressed={this.toggleButttonPressed}
                        />
                        ) : null}
                    {/* </Grid.Column> */}
                    </Grid.Row>
                    {this.props.selectedPracticeFlowActivity && !this.props.selectedPracticeFlowActivity.isParentNode && this.props.selectedPracticeFlowActivity.isLeafNode ?
                        <Grid.Row className="mar_t_10 pad_0 formcyForm" style={{}}>
                            <Grid.Column width={8} style={{display:"flex", alignItems:"center"}}>
                                <span>Smart Activity </span>
                                {/* <i className="info circle icon"></i> */}
                            {/* </Grid.Column>

                            <Grid.Column
                                width={5}
                                style={{}}> */}
                            <Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
								<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
							}
								content={<div style={{ display: 'block', width: '100%' }}><b>Smart Activity</b><br />Enabling this will auto-complete the activity after <br/> the Make.com scenario executed successfully.</div>}
							/>
                                <Checkbox
                                    toggle
                                    style={{marginLeft:"13px"}}
                                    // disabled={false ? "disabled" : "enabled"}
                                    disabled={this.props.status !== 0}
                                    // defaultChecked
                                    checked={SmartActivity}
                                    name="inte1"
                                    onChange={this.setActivitySmart}
                                />
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <div style={{ textAlign: 'right' }}>
                                    <span>
                                        <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt="milestone" />&nbsp;
                                        <span>Milestone Activity</span>
                                        <Checkbox className='diamond-location'
                                            checked={this.props.selectedPracticeFlowActivity ? this.props.selectedPracticeFlowActivity.isMilestone : Milestone}
                                            onChange={this.setMilestone}
                                            disabled={this.props.status !== 0}
                                        />
                                    </span>
                                </div>
                            </Grid.Column>
                        </Grid.Row>:""
                    }
                    {this.props.selectedPracticeFlowActivity && !this.props.selectedPracticeFlowActivity.isParentNode && this.props.selectedPracticeFlowActivity.isLeafNode ?
                        <Grid.Row className="mar_t_10 pad_0 formcyForm" style={{}}>
                            <Grid.Column width={8} style={{display:"flex", alignItems:"center",marginBottom:"10px"}}>
                                <span>Disable Activity</span>
                                 <Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
								<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
							}
								content={<div style={{ display: 'block', width: '100%' }}><b>Disable Activity</b><br />Once the activity is disabled, it will no longer  be <br/> included in initiatives created from this playbook.</div>}
							/>
                                <Checkbox
                                    toggle
                                    style={{marginLeft:"10px"}}
                                    disabled={this.props.status !== 0}
                                    checked={this.state.activityStatus}
                                    onChange={this.setActivityStatus}
                                />
                            </Grid.Column>
                          
                        </Grid.Row>:""
                    }
                </Grid>
            </Form>
        )
    }
}
function mapStateToProps(state) {
    return {
        user: state.app.user,
        playbookStatus: state.lifeCycle.playbookStatus
    };
}
const connectedCommunityActivityResourcePaneForm = connect(mapStateToProps)(CommunityActivityResourcePaneForm);
export default connectedCommunityActivityResourcePaneForm